import React from "react";
import { Route } from "react-router-dom";
import { getUsers } from "../../Api";
import UserList from "./UserList";
import EditUser from "./EditUser";
import { getVendors } from "../../Api";

interface AdminProps {
  url: string;
}

interface AdminState {
  data: Array<any>;
  isLoading: boolean;
  isError: boolean;
  selectedItem: any;
  itemWasUpdated: boolean;
  vendors: Array<any>;
  isLoadingVendors: boolean;
  isVendorsError: boolean;
}

class Admin extends React.Component<AdminProps, AdminState> {
  constructor(props: AdminProps) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      isError: false,
      selectedItem: null,
      itemWasUpdated: false,
      vendors: [],
      isLoadingVendors: true,
      isVendorsError: false,
    };
  }

  loadUsers() {
    getUsers(
      (data) => {
        this.setState({
          data: data,
          isLoading: false,
          isError: false,
          selectedItem: null,
          itemWasUpdated: false,
        });
      },
      (err) => {
        this.setState({
          isError: true,
          isLoading: false,
          data: [],
          selectedItem: null,
          itemWasUpdated: false,
        });
      }
    );
  }

  loadVendors() {
    getVendors(
      (data) => {
        this.setState({
          vendors: data,
          isLoadingVendors: false,
          isVendorsError: false,
        });
      },
      (err) => {
        this.setState({
          isVendorsError: true,
          isLoadingVendors: false,
          vendors: [],
        });
      }
    );
  }

  componentDidMount() {
    this.loadUsers();
    this.loadVendors();
  }

  componentDidUpdate() {
    if (this.state.itemWasUpdated) {
      this.loadUsers();
    }
  }

  render() {
    const onEditDoneHandler = () => {
      this.setState({ itemWasUpdated: true });
    };
    return (
      <>
        <Route path={`${this.props.url}/`} exact>
          <UserList
            data={this.state.data}
            isLoading={this.state.isLoading}
            isError={this.state.isError}
            onEditUser={(user) => this.setState({ selectedItem: user })}
          ></UserList>
        </Route>
        <Route path={`${this.props.url}/add-user`} exact>
          <EditUser
            vendors={this.state.vendors}
            onEditDone={onEditDoneHandler}
          ></EditUser>
        </Route>
        <Route path={`${this.props.url}/edit-user`} exact>
          <EditUser
            vendors={this.state.vendors}
            onEditDone={onEditDoneHandler}
            user={this.state.selectedItem}
          ></EditUser>
        </Route>
      </>
    );
  }
}

export default Admin;
